// @flow
import { connect, getIn, setIn } from 'formik';
import React from 'react';
import { Checkbox } from 'semantic-ui-react';

import { getMonthName, isMonthLockedByKafkaMonth } from './utils';

const ClusterMonthlyBooleanSetAll = ({
  totalNumberOfMonths,
  formik,
  usageMetric,
  monthlyEstimatesFieldName,
  disabled = false,
  shouldDisableMonthWhenCorrespondingKafkaMonthIsDisabled = false,
}) => {
  const getRowMonthFieldNames = () => {
    const monthsInFormik = getIn(formik.values, monthlyEstimatesFieldName).months;
    const fieldNames = [];

    for (let i = 1; i <= totalNumberOfMonths; i++) {
      const monthName = getMonthName(i);

      // Skip months the row itself won't let the user edit
      const isMonthLocked =
        monthsInFormik[monthName] == null ||
        isMonthLockedByKafkaMonth(
          formik.values,
          monthName,
          shouldDisableMonthWhenCorrespondingKafkaMonthIsDisabled
        );

      if (!isMonthLocked) {
        fieldNames.push(`${monthlyEstimatesFieldName}[months][${monthName}].${usageMetric}`);
      }
    }
    return fieldNames;
  };

  // The icon state comes from every month the row lets the user edit, so it still matches the
  // switches while the form has errors
  const rowFieldNames = getRowMonthFieldNames();
  const onCount = rowFieldNames.filter(
    (fieldName) => getIn(formik.values, fieldName) === true
  ).length;
  const areAllMonthsOn = rowFieldNames.length > 0 && onCount === rowFieldNames.length;

  // Like the Field wrapper, a toggle is locked while the form has errors, unless the error is on
  // that toggle
  const hasFormErrors = Object.keys(formik.errors).length !== 0;
  const fieldNames = rowFieldNames.filter(
    (fieldName) => !hasFormErrors || getIn(formik.errors, fieldName)
  );

  // Nothing to change when every month is locked (e.g. Kafka is disabled in all of them)
  const isCheckboxDisabled = disabled || fieldNames.length === 0;

  const getTitle = () => {
    if (fieldNames.length === 0) {
      return 'No months can be changed';
    }
    return areAllMonthsOn ? 'Turn all months off' : 'Turn all months on';
  };

  const handleClick = () => {
    // All on turns everything off; none or mixed turns everything on
    const newValue = !areAllMonthsOn;

    // set everything in one shot; setIn returns a new object each time
    let newValuesWithChangedMonthValues = formik.values;
    for (const fieldName of fieldNames) {
      newValuesWithChangedMonthValues = setIn(newValuesWithChangedMonthValues, fieldName, newValue);
    }

    formik.setValues(newValuesWithChangedMonthValues, false);
  };

  return (
    <Checkbox
      aria-label="Set all months"
      checked={areAllMonthsOn}
      disabled={isCheckboxDisabled}
      indeterminate={!areAllMonthsOn && onCount > 0}
      onChange={handleClick}
      style={{ marginRight: '0.25rem' }} // To be in line with the calculator.
      title={getTitle()}
    />
  );
};

export default connect(ClusterMonthlyBooleanSetAll);
